define('charts/layers/trim',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.TrimLayer = void 0;
    var TrimLayer = /** @class */ (function () {
        function TrimLayer(track, trimmer) {
            this.track = track;
            this.trimmer = trimmer;
        }
        TrimLayer.prototype.init = function (chart) {
            // Get the view bounds
            var height = chart.height();
            // Add the trim overlay group
            this.svgGroup = chart.layers.space.append("g")
                .attr("class", "trim")
                .style("clip-path", "url(#chart-clipping-time)")
                .style("display", "none")
                .style("fill", "#888")
                .style("fill-opacity", 0.15);
            this.rectMin = this.svgGroup.append("rect")
                .attr("class", "trim trim-min")
                .attr("x", 0)
                .attr("y", 0)
                .attr("height", height);
            this.rectMax = this.svgGroup.append("rect")
                .attr("class", "trim trim-max")
                .attr("x", 0)
                .attr("y", 0)
                .attr("height", height);
        };
        TrimLayer.prototype.update = function (chart) {
            var tight = this.trimmer.tightTrim();
            if (tight.min !== undefined && tight.max !== undefined) {
                var start = this.track.utcToBrowser(tight.min);
                var end = this.track.utcToBrowser(tight.max);
                var width0 = chart.xAxis.scale(start) - chart.xAxis.scale.range()[0];
                var width1 = chart.xAxis.scale.range()[1] - chart.xAxis.scale(end);
                width0 = Math.max(0, width0);
                width1 = Math.max(0, width1);
                this.svgGroup.style("display", null);
                this.rectMin.attr("width", width0);
                this.rectMax.attr("x", chart.xAxis.scale(end));
                this.rectMax.attr("width", width1);
            }
            else {
                this.svgGroup.style("display", "none");
            }
        };
        TrimLayer.prototype.remove = function () {
            this.svgGroup.remove();
        };
        return TrimLayer;
    }());
    exports.TrimLayer = TrimLayer;
});
//# sourceMappingURL=/assets/javascripts/charts/layers/trim.js.map;
